import { useQueries } from 'react-query';
import * as XLSX from 'xlsx';
import { httpRequest } from '../../../config/api';
import { AIF_TEMPLATE_SHEET, readTemplateFunds } from '../lib/aifTemplate';
import { isFileInProgress, isTableFile } from '../lib/fileKinds';

const readWorkbook = async file => {
  const blob = await httpRequest.get(`api/periods/${file.period_id}/files/${file.id}`, {
    responseType: 'blob'
  });
  const buffer = await (blob instanceof Blob ? blob : new Blob([blob])).arrayBuffer();
  const workbook = XLSX.read(new Uint8Array(buffer), {
    type: 'array',
    sheets: [AIF_TEMPLATE_SHEET]
  });
  return readTemplateFunds(workbook);
};

// The AIF columns of a period's workbooks, read in the browser the way the preview reads them.
export function useTemplateFunds(files) {
  const readable = (files || []).filter(file => isTableFile(file) && !isFileInProgress(file));
  const results = useQueries(
    readable.map(file => ({
      queryKey: ['CONVERSION_TEMPLATE_FUNDS', file.id, file.modified_at],
      queryFn: () => readWorkbook(file),
      staleTime: Infinity,
      retry: false
    }))
  );

  const read = results.filter(result => result.data);
  return {
    isChecking: results.some(result => result.isLoading),
    error: results.find(result => result.error)?.error || null,
    // Files that have no AIF Template sheet at all.
    withoutTemplate: readable.filter((file, index) => results[index]?.data?.hasTemplate === false),
    columns: [...new Set(read.flatMap(result => result.data.funds))],
    // Read, and at least one of them is a template to compare against.
    isRead:
      !!readable.length &&
      read.length === readable.length &&
      read.some(result => result.data.hasTemplate)
  };
}
